import Ip from './Ip'

export default Ip;
